<template>
  <div class="news">
    <div class="news-header">
      <div class="news-logo">
        <img
          src="@/assets/logo.png"
          alt=""
        />
      </div>
      <div class="news-des">
        英国大型医疗机构Circle Health在中国的唯一医疗机构
      </div>
    </div>
    <swiper
      ref="mySwiper"
      v-bind:options="swiperOptions"
    >
      <swiper-slide
        v-for="item in articleList"
        :key="item.id"
      >
        <div
          class="news-slide shadow-box"
          @click="goDetail(item)"
        >
          <div class="news-slide-img">
            <img
              :src="item.img_url"
              alt=""
            />
          </div>
          <div class="news-slide-content">
            <h3 class="news-slide-title ellipsis-1">
              {{ item.title }}
            </h3>
            <p class="news-slide-summary ellipsis-2">
              {{ item.zhaiyao }}
            </p>
            <div class="news-slide-footer">
              <span class="news-slide-footer-left">发布时间</span>
              <span class="news-slide-footer-right">
                {{ item.update_time_show }}
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    <div class="news-more-box">
      <div
        class="news-more"
        @click="goMore"
      >
        <span> 查看更多 </span>
        <img
          src="@/assets/images/arrow.png"
          alt=""
        >
      </div>
    </div>

  </div>
</template>

<script>
import newsService from "@/apis/news/index";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import { Swiper, SwiperSlide } from "@/thirdPackages/vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import moment from "moment";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      topArticleList: {},
      articleList: [],
      swiperOptions: {
        effect: "coverflow",
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 40,
        height: 435,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable :true,
        // }
      },
    };
  },
  created() {
    document.title = "健康资讯";
    this.getTopArticleList();
    // this.getArticleList();
  },
  methods: {
    getTopArticleList() {
      const params = {
        category_id: this.$route.params.type,
      };
      newsService.getTopArticleList(params).then((res) => {
        res.forEach((item) => {
          item.img_url = item.img_url.replace(
            "http://drclub.circleharmonyhealth.com",
            "https://drclub.circleharmonyhospital.cn"
          );
          item.update_time_show = item.update_time
            ? moment(item.update_time).format("YYYY-MM")
            : "";
        });
        res.update_time_show = moment(res.update_time).format("YYYY-MM");
        this.articleList = [...res, ...this.articleList];
        // this.topArticleList = res
        // console.log(res)
      });
    },
    getArticleList() {
      const params = {
        page_index: 1,
        page_size: 100,
        category_id: this.$route.params.type,
      };
      newsService.getArticleList(params).then((res) => {
        res.data.forEach((item) => {
          item.update_time_show = item.update_time
            ? moment(item.update_time).format("YYYY-MM")
            : "";
        });
        this.articleList = [...this.articleList, ...res.data];
      });
    },

    async goDetail(item) {
      if (!item.content) {
        const params = {
          id: item.id,
        };
        newsService.articleBrowseAddOne(params).then(() => {
          location.href = item.link_url;
        });
      } else {
        this.$router.push({
          name: "NewsDetail",
          params: {
            id: item.id,
          },
        });
      }
    },
    goMore() {
      this.$router.push({
        name: "NewsSearch",
        params: {
          ...this.$route.params,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.news-more-box {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news-more {
  height: 60px;
  width: 60px;
  border-radius: 100%;
  border: 1px solid #e7635e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  span {
    font-size: 10px;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    width: 24px;
  }
  img {
    width: 12.64px;
    height: 2.26px;
    margin-top: 3px;
  }
}
.news-header {
  padding: 0 30px;
  margin-top: 57px;
  margin-bottom: 20px;
  padding-left: 9.5%;
  .news-logo {
    width: 134px;
    height: 31px;
    img {
      height: 100%;
      width: 100%;
    }
    position: relative;
    &::before {
      content: " ";
      position: absolute;
      width: 3px;
      height: 24px;
      background: #e7635e;
      border-radius: 10px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: -15px;
    }
  }
  .news-des {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
  }
}
.news-slide {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 28px 33px 3px rgba(233, 231, 234, 0.5);
  .news-slide-content {
    padding: 0 15px;
    padding-bottom: 20px;
  }
  .news-slide-img {
    height: 30vh;
    max-height: 280px;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .news-slide-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    // line-height: 18px;
    margin: 0;
    margin-top: 20px;
  }
  .news-slide-summary {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    height: 40px;
  }
  .news-slide-footer {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    border-top: 1px solid #f0f2f6;
    padding-top: 15px;
  }
}
.swiper-container {
  // background: #f00;
}
.swiper-slide {
  // height: 435px;
  box-shadow: 0px 28px 33px 3px rgba(233, 231, 234, 0.5);
  border-radius: 10px;
}
// .swiper-slide-prev {
//       transform: translate3d(-490px, 0px, -1000px) rotateX(0deg) rotateY(0deg) !important;
// }
// .swiper-slide-active {
//   width: 90% !important;
// }
.news {
  // padding: 15px;
}
.news-main {
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
  .news-title {
    margin: 15px 0 10px 0;
  }
  .news-sub {
    margin: 0;
  }
}
.news-list {
  margin-top: 20px;
  padding: 0 15px;
}
.news-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f6;
  padding: 15px 0;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
}
.news-item-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .news-title {
    line-height: 22px;
    margin: 0;
  }
  .news-sub {
    margin: 0;
  }
}
.news-item-right {
  width: 120px;
  height: 80px;
  margin-left: 10px;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
</style>

<style lang="less">
.swiper-container-3d .swiper-slide-shadow-left {
  opacity: 0 !important;
}
.swiper-container-3d .swiper-slide-shadow-right {
  opacity: 0.3 !important;
  background: #fff;
}
.swiper-slide-active {
  .swiper-slide-shadow-left {
    opacity: 0 !important;
  }
  .swiper-slide-shadow-right {
    opacity: 0 !important;
    background: #fff;
  }
}
.swiper-container {
  overflow: unset !important;
}
.swiper-pagination {
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 20px;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -30px;
}
.swiper-pagination-bullet {
  height: 10px;
  width: 10px;
  margin: 0 10px;
  border: 2px solid #d8d8d8;
  background-color: transparent;
  box-sizing: border-box;
}
.swiper-pagination-bullet-active {
  background: #e7635e;
  border-color: #e7635e;
}
</style>